<template>
  <!-- 我的客户：5 个 tab，pool=false 兜底排除公海数据（转入公海后本页不再显示） -->
  <CustomerList :pool="false" :show-create="true" :show-tabs="true" />
</template>

<script lang="ts" setup>
import CustomerList from './components/CustomerList.vue'

defineOptions({ name: 'CrmCustomer' })
</script>
